(function () {
  const container = document.querySelector('[data-tagembed-lazy]');
  if (!container) return;

  function loadWidget() {
    if (document.querySelector('script[data-tagembed-script]')) return;
    const script = document.createElement('script');
    script.src = 'https://widget.tagembed.com/embed.min.js';
    script.async = true;
    script.dataset.tagembedScript = 'true';
    document.body.appendChild(script);
  }

  if (!('IntersectionObserver' in window)) {
    loadWidget();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadWidget();
          observer.disconnect();
        }
      });
    },
    { rootMargin: '300px' }
  );
  observer.observe(container);
})();
